var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___dnljYX",
  "uW": "GuildNotificationSettingsModal.module__section___dnljYX",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___dnljYX",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___dnljYX",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___dnljYX",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___dnljYX",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___dnljYX",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___dnljYX",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___dnljYX",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___dnljYX",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___dnljYX",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___dnljYX",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___dnljYX",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___dnljYX",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___dnljYX",
  "p": "GuildNotificationSettingsModal.module__channelIcon___dnljYX",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___dnljYX",
  "HA": "GuildNotificationSettingsModal.module__channelName___dnljYX",
  "yb": "GuildNotificationSettingsModal.module__categoryName___dnljYX",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___dnljYX",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___dnljYX",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___dnljYX",
  "DT": "GuildNotificationSettingsModal.module__removeButton___dnljYX",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___dnljYX",
};

module.exports = exports;
